function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import IconBase, { SMALL_VIEWBOX } from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function CloseIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M5 5l14 14m0-14L5 19"
  }));
}
export function CloseIconSmall(props) {
  return ___EmotionJSX(IconBase, _extends({
    size: "small",
    viewBox: SMALL_VIEWBOX
  }, props), ___EmotionJSX("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M5 5l8 8M5 13l8-8"
  }));
}